import React from 'react';
import Component from '@vfuk/core-initials-avatar';
const InitialsAvatar = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default InitialsAvatar;
